import type { OpenAnswerQuestion, SingleAnswerQuestion } from '@feh/shared-ui';

export const homebatteryQuestionnaireStructure: {
  [key: string]: SingleAnswerQuestion | OpenAnswerQuestion;
} = {
  hasEnergyContract: {
    type: 'single-answer-question',
    question: 'Heb je een energiecontract bij Essent?',
    apiKey: 'hasEnergyContract',
    trackingStepName: 'hasEnergyContract',
    percentage: 20,
    options: [
      {
        label: 'Ja',
        automationId: 'hasEnergyContract.yes',
        apiValue: true,
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
      {
        label: 'Nee',
        apiValue: false,
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
    ],
  },
  contractType: {
    type: 'single-answer-question',
    question: 'Wat voor energiecontract heb je?',
    apiKey: 'contractType',
    trackingStepName: 'contractType',
    percentage: 40,
    options: [
      {
        label: 'Vast contract',
        automationId: 'contractType.fixedContract',
        apiValue: 'fixed',
        target: {
          type: 'next-question',
          questionName: 'hasSolarPanels',
        },
      },
      {
        label: 'Variabel contract',
        apiValue: 'variable',
        target: {
          type: 'next-question',
          questionName: 'hasSolarPanels',
        },
      },
      {
        label: 'Dynamisch contract',
        automationId: 'contractType.dynamicContract',
        apiValue: 'Dynamisch contract',
        target: {
          type: 'next-question',
          questionName: 'hasSolarPanels',
        },
      },
      {
        label: 'Weet ik niet',
        apiValue: null,
        target: {
          type: 'next-question',
          questionName: 'hasSolarPanels',
        },
      },
    ],
    info: {
      label: 'Uitleg over contracten',
      target: {
        type: 'info-modal',
        funnelKey: 'infoContractType',
      },
    },
  },
  hasSolarPanels: {
    type: 'single-answer-question',
    question: 'Heb je zonnepanelen?',
    apiKey: 'hasSolarPanels',
    trackingStepName: 'hasSolarPanels',
    percentage: 60,
    options: [
      {
        label: 'Ja',
        automationId: 'hasSolarPanels.yes',
        apiValue: true,
        target: {
          type: 'next-question',
          questionName: 'numberOfPanels',
        },
      },
      {
        label: 'Nee',
        automationId: 'hasSolarPanels.no',
        apiValue: false,
        target: {
          type: 'link',
          funnelKey: 'orderPage',
        },
      },
    ],
  },
  numberOfPanels: {
    type: 'open-answer-question',
    question: 'Hoeveel zonnepanelen heb je?',
    apiKey: 'numberOfPanels',
    automationId: 'numberOfPanels',
    trackingStepName: 'numberOfPanels',
    percentage: 80,
    target: {
      type: 'link',
      funnelKey: 'orderPage',
    },
    label: 'Vul een aantal zonnepanelen in',
    suffix: 'panelen',
    min: 1,
    max: 42,
  },
};
